import { type LotteryTicketType } from '@/common/types/lottery';

import diamondPng from '/img/lottery/diamond.png';
import diamondWebp from '/img/lottery/diamond.webp';
import goldPng from '/img/lottery/gold.png';
import goldWebp from '/img/lottery/gold.webp';
import silverPng from '/img/lottery/silver.png';
import silverWebp from '/img/lottery/silver.webp';

const imagesList: { img: string; webp: string; alt: string }[] = [
  {
    img: silverPng,
    webp: silverWebp,
    alt: 'silver ticket',
  },
  {
    img: goldPng,
    webp: goldWebp,
    alt: 'gold ticket',
  },
  {
    img: diamondPng,
    webp: diamondWebp,
    alt: 'diamond ticket',
  },
];

const position: Record<LotteryTicketType, { x: string | number }> = {
  Silver: { x: 0 },
  Gold: { x: '-33.33%' },
  Diamond: { x: '-66.66%' },
};

export { imagesList, position };
